module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin23-0eba4de1a754ce4ca383a208262ad0bd.jpg";